var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("header-programa", {
                attrs: { programa: _vm.solicitud?.programa },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _vm.mostrarTexto
              ? _c("h5", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("apeironGwApp.programa.obligatorio")
                    ),
                  },
                })
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "accordion", attrs: { role: "tablist" } },
                [
                  _vm.esEscritura
                    ? _c(
                        "b-card",
                        { staticClass: "mb-1", attrs: { "no-body": "" } },
                        [
                          _c(
                            "b-card-header",
                            {
                              staticClass: "p-1",
                              attrs: { "header-tag": "header", role: "tab" },
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle.accordion-1",
                                      modifiers: { "accordion-1": true },
                                    },
                                  ],
                                  attrs: { block: "", variant: "light" },
                                },
                                [
                                  _c("h5", {
                                    staticClass: "mb-0",
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.programa.camposConocimiento.registrarCampo"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              attrs: {
                                id: "accordion-1",
                                accordion: "accordion-lies",
                                role: "tabpanel",
                              },
                              model: {
                                value: _vm.mostrarSeccionRegistro,
                                callback: function ($$v) {
                                  _vm.mostrarSeccionRegistro = $$v
                                },
                                expression: "mostrarSeccionRegistro",
                              },
                            },
                            [
                              _c(
                                "b-card-body",
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              staticClass: "mb-2",
                                              attrs: {
                                                label:
                                                  _vm
                                                    .$t(
                                                      "apeironGwApp.programa.camposConocimiento.areaConocimiento"
                                                    )
                                                    .toString() + " *",
                                                "label-for": "input-area",
                                              },
                                            },
                                            [
                                              _c(
                                                "b-form-select",
                                                {
                                                  staticClass:
                                                    "resaltar-opciones-disabled",
                                                  attrs: {
                                                    name: "input-area",
                                                    disabled:
                                                      _vm.areas.length < 1,
                                                    state:
                                                      !_vm.$v.areaConocimiento
                                                        .area.$invalid,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.obtenerCampos(
                                                        $event
                                                      )
                                                    },
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "first",
                                                        fn: function () {
                                                          return [
                                                            _c(
                                                              "b-form-select-option",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    undefined,
                                                                  disabled: "",
                                                                },
                                                              },
                                                              [
                                                                _c("span", {
                                                                  domProps: {
                                                                    textContent:
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "apeironGwApp.programa.camposConocimiento.seleccionarUno"
                                                                        )
                                                                      ),
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    774656104
                                                  ),
                                                  model: {
                                                    value:
                                                      _vm.areaConocimiento.area,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.areaConocimiento,
                                                        "area",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "areaConocimiento.area",
                                                  },
                                                },
                                                [
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.areas,
                                                    function (item, index) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: index,
                                                          domProps: {
                                                            value: item,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                item.nombre
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c("small", {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.$v.areaConocimiento
                                                        .area.$invalid,
                                                    expression:
                                                      "$v.areaConocimiento.area.$invalid",
                                                  },
                                                ],
                                                staticClass: "text-danger",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "entity.validation.required"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              staticClass: "mb-2",
                                              attrs: {
                                                label:
                                                  _vm
                                                    .$t(
                                                      "apeironGwApp.programa.camposConocimiento.campo"
                                                    )
                                                    .toString() + " *",
                                                "label-for": "input-campo",
                                              },
                                            },
                                            [
                                              _c("b-form-select", {
                                                staticClass:
                                                  "resaltar-opciones-disabled",
                                                attrs: {
                                                  name: "input-campo",
                                                  options: _vm.catalogoCampo,
                                                  disabled:
                                                    _vm.catalogoCampo.length <
                                                    1,
                                                  state:
                                                    !_vm.$v.areaConocimiento
                                                      .campo.$invalid,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.obtenerDisciplinas(
                                                      $event
                                                    )
                                                  },
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "first",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "b-form-select-option",
                                                            {
                                                              attrs: {
                                                                value:
                                                                  undefined,
                                                                disabled: "",
                                                              },
                                                            },
                                                            [
                                                              _c("span", {
                                                                domProps: {
                                                                  textContent:
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "apeironGwApp.programa.camposConocimiento.seleccionarUno"
                                                                      )
                                                                    ),
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  774656104
                                                ),
                                                model: {
                                                  value:
                                                    _vm.areaConocimiento.campo,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.areaConocimiento,
                                                      "campo",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "areaConocimiento.campo",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("small", {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.$v.areaConocimiento
                                                        .campo.$invalid,
                                                    expression:
                                                      "$v.areaConocimiento.campo.$invalid",
                                                  },
                                                ],
                                                staticClass: "text-danger",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "entity.validation.required"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              staticClass: "mb-2",
                                              attrs: {
                                                label:
                                                  _vm
                                                    .$t(
                                                      "apeironGwApp.programa.camposConocimiento.disciplina"
                                                    )
                                                    .toString() + " *",
                                                "label-for": "input-disciplina",
                                              },
                                            },
                                            [
                                              _c("b-form-select", {
                                                staticClass:
                                                  "resaltar-opciones-disabled",
                                                attrs: {
                                                  name: "input-disciplina",
                                                  options:
                                                    _vm.catalogoDisciplina,
                                                  disabled:
                                                    _vm.catalogoDisciplina
                                                      .length < 1,
                                                  state:
                                                    !_vm.$v.areaConocimiento
                                                      .disciplina.$invalid,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.obtenerSubDisciplinas(
                                                      $event
                                                    )
                                                  },
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "first",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "b-form-select-option",
                                                            {
                                                              attrs: {
                                                                value:
                                                                  undefined,
                                                                disabled: "",
                                                              },
                                                            },
                                                            [
                                                              _c("span", {
                                                                domProps: {
                                                                  textContent:
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "apeironGwApp.programa.camposConocimiento.seleccionarUno"
                                                                      )
                                                                    ),
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  774656104
                                                ),
                                                model: {
                                                  value:
                                                    _vm.areaConocimiento
                                                      .disciplina,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.areaConocimiento,
                                                      "disciplina",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "areaConocimiento.disciplina",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("small", {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.$v.areaConocimiento
                                                        .disciplina.$invalid,
                                                    expression:
                                                      "$v.areaConocimiento.disciplina.$invalid",
                                                  },
                                                ],
                                                staticClass: "text-danger",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "entity.validation.required"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              staticClass: "mb-2",
                                              attrs: {
                                                label:
                                                  _vm
                                                    .$t(
                                                      "apeironGwApp.programa.camposConocimiento.subDisciplina"
                                                    )
                                                    .toString() + " *",
                                                "label-for":
                                                  "input-subDisciplina",
                                              },
                                            },
                                            [
                                              _c("b-form-select", {
                                                staticClass:
                                                  "resaltar-opciones-disabled",
                                                attrs: {
                                                  name: "input-subDisciplina",
                                                  options:
                                                    _vm.catalogoSubdisciplina,
                                                  disabled:
                                                    _vm.catalogoSubdisciplina
                                                      .length < 1,
                                                  state:
                                                    !_vm.$v.areaConocimiento
                                                      .subdisciplina.$invalid,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "first",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "b-form-select-option",
                                                            {
                                                              attrs: {
                                                                value:
                                                                  undefined,
                                                                disabled: "",
                                                              },
                                                            },
                                                            [
                                                              _c("span", {
                                                                domProps: {
                                                                  textContent:
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "apeironGwApp.programa.camposConocimiento.seleccionarUno"
                                                                      )
                                                                    ),
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  774656104
                                                ),
                                                model: {
                                                  value:
                                                    _vm.areaConocimiento
                                                      .subdisciplina,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.areaConocimiento,
                                                      "subdisciplina",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "areaConocimiento.subdisciplina",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("small", {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.$v.areaConocimiento
                                                        .subdisciplina.$invalid,
                                                    expression:
                                                      "$v.areaConocimiento.subdisciplina.$invalid",
                                                  },
                                                ],
                                                staticClass: "text-danger",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "entity.validation.required"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                (
                                                  _vm.areaConocimiento
                                                    .disciplina?.nombre ?? ""
                                                ).startsWith("Otra") ||
                                                (
                                                  _vm.areaConocimiento
                                                    .disciplina?.nombre ?? ""
                                                ).startsWith("Otro"),
                                              expression:
                                                "\n                    (areaConocimiento.disciplina?.nombre ?? '').startsWith('Otra') ||\n                    (areaConocimiento.disciplina?.nombre ?? '').startsWith('Otro')\n                  ",
                                            },
                                          ],
                                          attrs: { cols: "6" },
                                        },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              staticClass: "mb-2",
                                              attrs: {
                                                label:
                                                  _vm.$t(
                                                    "apeironGwApp.programa.camposConocimiento.otraDisciplina"
                                                  ) +
                                                  ((
                                                    _vm.areaConocimiento
                                                      .disciplina?.nombre ?? ""
                                                  ).startsWith("Otra") ||
                                                  (
                                                    _vm.areaConocimiento
                                                      .disciplina?.nombre ?? ""
                                                  ).startsWith("Otro")
                                                    ? " *"
                                                    : ""),
                                                "label-for":
                                                  "input-otra-disciplina",
                                              },
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "input-otra-disciplina",
                                                  placeholder: _vm.$t(
                                                    "apeironGwApp.programa.camposConocimiento.otraDisciplina"
                                                  ),
                                                  state:
                                                    !_vm.$v.areaConocimiento
                                                      .otraDisciplina.$invalid,
                                                },
                                                model: {
                                                  value:
                                                    _vm.areaConocimiento
                                                      .otraDisciplina,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.areaConocimiento,
                                                      "otraDisciplina",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "areaConocimiento.otraDisciplina",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                (
                                                  _vm.areaConocimiento
                                                    .subdisciplina?.nombre ?? ""
                                                ).startsWith("Otra") ||
                                                (
                                                  _vm.areaConocimiento
                                                    .subdisciplina?.nombre ?? ""
                                                ).startsWith("Otro"),
                                              expression:
                                                "\n                    (areaConocimiento.subdisciplina?.nombre ?? '').startsWith('Otra') ||\n                    (areaConocimiento.subdisciplina?.nombre ?? '').startsWith('Otro')\n                  ",
                                            },
                                          ],
                                          attrs: { cols: "6" },
                                        },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              staticClass: "mb-2",
                                              attrs: {
                                                label:
                                                  _vm.$t(
                                                    "apeironGwApp.programa.camposConocimiento.otraSubdisciplina"
                                                  ) +
                                                  ((
                                                    _vm.areaConocimiento
                                                      .subdisciplina?.nombre ??
                                                    ""
                                                  ).startsWith("Otra") ||
                                                  (
                                                    _vm.areaConocimiento
                                                      .subdisciplina?.nombre ??
                                                    ""
                                                  ).startsWith("Otro")
                                                    ? " *"
                                                    : ""),
                                                "label-for":
                                                  "input-otra-subdisciplina",
                                              },
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "input-otra-subdisciplina",
                                                  placeholder: _vm.$t(
                                                    "apeironGwApp.programa.camposConocimiento.otraSubdisciplina"
                                                  ),
                                                  state:
                                                    !_vm.$v.areaConocimiento
                                                      .otraSubdisciplina
                                                      .$invalid,
                                                },
                                                model: {
                                                  value:
                                                    _vm.areaConocimiento
                                                      .otraSubdisciplina,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.areaConocimiento,
                                                      "otraSubdisciplina",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "areaConocimiento.otraSubdisciplina",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "text-right",
                                          attrs: {
                                            sm: "12",
                                            md: "12",
                                            lg: "12",
                                          },
                                        },
                                        [
                                          _vm.esEscritura
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    variant: "primary",
                                                    disabled: _vm.activarBoton,
                                                  },
                                                  on: {
                                                    click: _vm.agregarArea,
                                                  },
                                                },
                                                [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "entity.action.add"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("b-icon", {
                                                    attrs: { icon: "save" },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c("b-col", [
                                        _c("strong", [
                                          _c(
                                            "mark",
                                            { staticClass: "text-primary" },
                                            [
                                              _c("em", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.programa.camposConocimiento.agregaCampo"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    { staticClass: "mb-1", attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-card-header",
                        {
                          staticClass: "p-1",
                          attrs: { "header-tag": "header", role: "tab" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.accordion-2",
                                  modifiers: { "accordion-2": true },
                                },
                              ],
                              attrs: { block: "", variant: "light" },
                            },
                            [
                              _c("h5", {
                                staticClass: "mb-0",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.programa.camposConocimiento.listaCampos"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-collapse",
                        {
                          attrs: {
                            id: "accordion-2",
                            accordion: "accordion-lies",
                            role: "tabpanel",
                          },
                          model: {
                            value: _vm.mostrarLista,
                            callback: function ($$v) {
                              _vm.mostrarLista = $$v
                            },
                            expression: "mostrarLista",
                          },
                        },
                        [
                          _c(
                            "b-card-body",
                            [
                              _c("b-table", {
                                staticClass: "area-responsive",
                                staticStyle: { "max-height": "500px" },
                                attrs: {
                                  "sticky-header": "500px",
                                  fields: _vm.fieldsSolicitudes,
                                  items: _vm.areasConocimiento,
                                  "thead-class": "custom-header",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "cell(disciplina)",
                                    fn: function ({ item }) {
                                      return [
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              item.disciplina
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: item.otraDisciplina,
                                              expression: "item.otraDisciplina",
                                            },
                                          ],
                                          domProps: {
                                            textContent: _vm._s(
                                              `(${item.otraDisciplina})`
                                            ),
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(subDisciplina)",
                                    fn: function ({ item }) {
                                      return [
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              item.subDisciplina
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !!item.otraSubDisciplina,
                                              expression:
                                                "!!item.otraSubDisciplina",
                                            },
                                          ],
                                          domProps: {
                                            textContent: _vm._s(
                                              `(${item.otraSubDisciplina})`
                                            ),
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(esPrincipal)",
                                    fn: function ({ item }) {
                                      return [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: item.esPrincipal
                                              ? "toggle-on"
                                              : "toggle-off",
                                            variant: item.esPrincipal
                                              ? "success"
                                              : "secondary",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t(
                                                item.esPrincipal
                                                  ? "apeironGwApp.programa.camposConocimiento.si"
                                                  : "apeironGwApp.programa.camposConocimiento.no"
                                              )
                                            ),
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(accion)",
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "btn-group" },
                                          [
                                            _vm.esEscritura && !item.esPrincipal
                                              ? _c(
                                                  "b-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover.right",
                                                        value: _vm.$t(
                                                          "apeironGwApp.programa.camposConocimiento.hacerPrincipal"
                                                        ),
                                                        expression:
                                                          "$t('apeironGwApp.programa.camposConocimiento.hacerPrincipal')",
                                                        modifiers: {
                                                          hover: true,
                                                          right: true,
                                                        },
                                                      },
                                                    ],
                                                    attrs: {
                                                      variant:
                                                        "outline-primary",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.mostrarModalConfirmacionAreaPrincipal(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("b-icon", {
                                                      attrs: {
                                                        icon: "exclamation-circle",
                                                        variant: "primary",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.esEscritura && item.esPrincipal
                                              ? _c(
                                                  "b-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover.right",
                                                        value: _vm.$t(
                                                          "apeironGwApp.programa.camposConocimiento.quitarPrincipal"
                                                        ),
                                                        expression:
                                                          "$t('apeironGwApp.programa.camposConocimiento.quitarPrincipal')",
                                                        modifiers: {
                                                          hover: true,
                                                          right: true,
                                                        },
                                                      },
                                                    ],
                                                    attrs: {
                                                      variant:
                                                        "outline-primary",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.mostrarModalQuitarAreaPrincipal(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("b-icon", {
                                                      attrs: {
                                                        icon: "exclamation-circle-fill",
                                                        variant: "primary",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.esEscritura && !item.esPrincipal
                                              ? _c(
                                                  "b-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover",
                                                        modifiers: {
                                                          hover: true,
                                                        },
                                                      },
                                                    ],
                                                    attrs: {
                                                      variant: "outline-danger",
                                                      title: _vm.$t(
                                                        "apeironGwApp.programa.camposConocimiento.eliminar"
                                                      ),
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.mostrarModalConfirmacionEliminarArea(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "mr-2",
                                                      attrs: { icon: "trash" },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { staticClass: "text-right" },
                                    [
                                      _vm.esEscritura
                                        ? _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                variant: "primary",
                                                disabled:
                                                  _vm.areasConocimiento
                                                    .length === 0,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.guardarSeccion()
                                                },
                                              },
                                            },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t("entity.action.save")
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("font-awesome-icon", {
                                                staticClass: "mr-2",
                                                attrs: { icon: "save" },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "confirmarModalEliminar",
          attrs: {
            title: _vm.$t(
              "apeironGwApp.programa.camposConocimiento.tituloModalEliminarCampo"
            ),
            "hide-footer": "",
          },
        },
        [
          _c(
            "b-row",
            [
              _c("b-col", [
                _c("div", { staticClass: "form-group" }, [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "apeironGwApp.programa.camposConocimiento.eliminarCampolista"
                        )
                      ),
                    },
                  }),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "text-center justify-content-center" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.confirmarAccionEliminarArea()
                          },
                        },
                      },
                      [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("entity.action.confirm")
                            ),
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.ocultarModalEliminarArea()
                          },
                        },
                      },
                      [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(_vm.$t("entity.action.cancel")),
                          },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "confirmarModalPrincipal",
          attrs: {
            title: _vm.$t(
              "apeironGwApp.programa.camposConocimiento.tituloModalAreaPrincipal"
            ),
            "hide-footer": "",
          },
        },
        [
          _c(
            "b-row",
            [
              _c("b-col", [
                _c("div", { staticClass: "form-group" }, [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "apeironGwApp.programa.camposConocimiento.areaPrincipal"
                        )
                      ),
                    },
                  }),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "text-center justify-content-center" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.confirmarAccionAreaPrincipal()
                          },
                        },
                      },
                      [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("entity.action.confirm")
                            ),
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.ocultarModalAreaPrincipal()
                          },
                        },
                      },
                      [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(_vm.$t("entity.action.cancel")),
                          },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "confirmarModalNoPrincipal",
          attrs: {
            title: _vm.$t(
              "apeironGwApp.programa.camposConocimiento.tituloModalAreaPrincipal"
            ),
            "hide-footer": "",
          },
        },
        [
          _c(
            "b-row",
            [
              _c("b-col", [
                _c("div", { staticClass: "form-group" }, [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "apeironGwApp.programa.camposConocimiento.noAreaPrincipal"
                        )
                      ),
                    },
                  }),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "text-center justify-content-center" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.confirmarAccionQuitarAreaPrincipal()
                          },
                        },
                      },
                      [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("entity.action.confirm")
                            ),
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.ocultarModalAreaPrincipal()
                          },
                        },
                      },
                      [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(_vm.$t("entity.action.cancel")),
                          },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }